import { AllSameKeyValuesEnforcer } from "../helpers/helpers"
import { addExcludedEntityTemplateKeys, EntityBase, entityProps } from "./entity.shared.data"
import { FilterGroup } from "./filters.data"

interface AttendeeTabs { info, sessions, quickNotes, configBrief, preview, briefInfo, contact, tasks, assets, schedule }
export const attendeeTabs: AllSameKeyValuesEnforcer<AttendeeTabs> = { info: 'info', sessions: 'sessions', quickNotes: 'quickNotes', configBrief: 'configBrief', preview: 'preview', briefInfo: 'briefInfo', contact: 'contact', tasks: 'tasks', assets: 'assets', schedule: 'schedule' }

export interface Attendee extends EntityBase {
  line1?: string
  line2?: string
  WFContact?: string // an email for a WFWorker
  photoHidden?: boolean // this is a data hack to get down to the timeline item level in the simplest way possible.
  photoUrl?: string
  fullPhotoUrl?: string
  phone?: string
  email?: string
  showEditProfileLinkInBrief?: boolean // when active, of course
}

const attendeeOnlyProps: AllSameKeyValuesEnforcer<Omit<Attendee, keyof EntityBase>> = {
  WFContact: 'WFContact', line1: 'line1', line2: 'line2', email: 'email', phone: 'phone', photoHidden: 'photoHidden', photoUrl: 'photoUrl', fullPhotoUrl: 'fullPhotoUrl', showEditProfileLinkInBrief: 'showEditProfileLinkInBrief'
}
export const attendeeProps: AllSameKeyValuesEnforcer<Attendee> = { ...entityProps, ...attendeeOnlyProps }


export const excludedTemplateAttendeeProps: Set<keyof Attendee> = new Set(['showEditProfileLinkInBrief', 'photoHidden'])
addExcludedEntityTemplateKeys(excludedTemplateAttendeeProps)

export const filterAttendees = (filters: FilterGroup, attendeeList: Attendee[]): Attendee[] => {
  attendeeList = attendeeList.filter(a => ![
    () => !filters.attendeeLabels || (a.labels && a.labels.some(l => filters.attendeeLabels.includes(l))),
    () => !filters.tags || (a.WFContact && filters.tags.includes(a.WFContact)),
    () => !filters.types || (filters.types.includes(a.entityTypeId))
  ].some(passesFilterFunction => !passesFilterFunction()))
  return attendeeList
}